import anime from 'animejs/lib/anime.es.js'

export default class VueAnime {
  // el 控制元素， fn 回调函数
  /*
   * maskIn and maskOut control opacity
   */
  maskIn (el, fn, duration = 300, delay = 0) {
    anime({
      targets: el,
      opacity: 1,
      duration: duration,
      delay: delay,
      easing: 'easeInQuad',
      begin () { // maskIn 开始执行的同时执行回调函数
        if (typeof fn === 'function') fn()
      }
    })
  }
  maskOut (el, fn, duration = 200, delay = 400) {
    anime({
      targets: el,
      opacity: 0,
      duration: duration,
      delay: delay,
      easing: 'easeInQuad',
      complete () { // maskOut 结束后执行回调函数
        if (typeof fn === 'function') fn()
      }
    })
  }
  /*
   * topIn and topOut control spring effect
   */
  topIn (el, duration = 800) { // from top
    anime({
      targets: el,
      top: ['0%', '50%'],
      duration: duration
    })
  }
  topOut (el, fn, duration = 600) { // to top
    anime({
      targets: el,
      top: ['50%', '0%'],
      duration: duration,
      easing: 'easeInBack',
      begin () {
        if (typeof fn === 'function') fn()
      }
    })
  }
  /* heartBeatIn
   * heartBeatOut
   */
  heartBeatIn (el, duration = 800) {
    anime({
      targets: el,
      scale: [0.6, 1],
      duration: duration
    })
  }
  heartBeatOut (el, fn, duration = 500, delay = 0) {
    anime({
      targets: el,
      scale: [1, 0.6],
      duration: duration,
      delay: delay,
      easing: 'easeInBack',
      begin () {
        if (typeof fn === 'function') fn()
      }
    })
  }
  /**
   * swing
   **/
  swing (el, duration = 100, delay = 0) {
    return anime({ // 使用闭包返回动画
      targets: el,
      rotate: ['1.5deg', '-1.5deg'],
      duration: duration,
      delay: delay,
      direction: 'alternate',
      easing: 'easeInOutCubic',
      loop: true
    })
  }
  /**
   * TimeLine
   **/
  timeline (el, begin, fn, duration = 50) {
    return anime.timeline({
      targets: el,
      duration: duration,
      autoplay: false,
      delay: (el, i) => { return i * 200 },
      easing: 'easeOutExpo',
      begin () {
        if (typeof begin === 'function') begin()
      },
      complete () {
        if (typeof fn === 'function') fn()
      }
    })
  }
  /**
   * Toast
   */
  toast (el, fn, duration = 500, endDelay = 600) {
    anime({
      targets: el,
      opacity: [0, 1],
      rotateX: ['90deg', 0],
      duration: duration,
      endDelay: endDelay,
      easing: 'spring(1, 100, 10, 10)',
      complete () {
        if (typeof fn === 'function') fn()
      }
    })
  }
  toastHide (el, fn, duration = 300) {
    anime({
      targets: el,
      rotateX: [0, '90deg'],
      opacity: [1, 0],
      easing: 'linear',
      duration: duration,
      complete () {
        if (typeof fn === 'function') fn()
      }
    })
  }
  message (el, duration = 500) {
    anime({
      targets: el,
      translateY: ['100%', 0],
      opacity: [0, 1],
      duration: duration > 500 ? duration : 500
    })
  }
  rotateY (el, complete, duration = 600) {
    anime({
      targets: el,
      rotateY: ['180deg', 0],
      duration: duration,
      easing: 'easeOutQuad',
      endDelay: 300,
      complete () {
        if (typeof complete === 'function') complete()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/animate.js